<template>
    <div class="proofy-preview noscroll flex layout-column">
        <div class="layout-column proofy-container" style="    padding: 10px 15px;">
	        <div class="">
		        <div class="proofy-popup proofy default" :class="theme">
			        <div class="image">
				        <img src="https://images.funnelish.com/proofy/london/AYORsUfUMApsVgzHblmY" class="avatar">
			        </div>
			        <div class="default-message">
				        <span>
									<div class="default-message">
										<div class="customer" style="font-weight: bold;">
											<span>James from Lose Angelos, California</span>
										</div>
										<div class="msg" style="">
											<span>{{ msg }}</span>
										</div>

										<div class="time">
									    <time>10 seconds ago</time>
            `           <span class="verified-by">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" >
                                <g clip-path="url(#clip0)">
                                    <path d="M14 7.0001L12.4151 5.24049L12.6633 2.88479L10.3458 2.39419L9.16362 0.340576L7.00001 1.30757L6.70798 7.0001L7.00001 12.6926L9.16365 13.6596L10.3458 11.606L12.6633 11.1154L12.4151 8.75968L14 7.0001Z" fill="#0ED678"></path>
                                    <path d="M4.83634 0.340576L3.65422 2.39419L1.33672 2.88482L1.58486 5.24049L0 7.0001L1.58486 8.75968L1.33672 11.1154L3.65422 11.606L4.83637 13.6596L7.00001 12.6926V1.30757L4.83634 0.340576Z" fill="#0ED678"></path>
                                    <path d="M10.6213 4.91777L9.86463 4.19995L6.99725 7.61409L6.6366 8.46256L6.99725 9.23291L10.6213 4.91777Z" fill="#F7F0EB"></path>
                                    <path d="M3.98384 6.11768L3.26666 6.87991L6.282 10.0846L6.99725 9.23293V7.61411L6.24014 8.51558L3.98384 6.11768Z" fill="#FFFBF5"></path>
                                </g>
                                <defs>
                                    <clipPath id="clip0">
                                        <rect width="14" height="14" fill="white"></rect>
                                    </clipPath>
                                </defs>
                            </svg>
                            verified by
                            <a target="_blank" href="https://funnelish.com?utm_source=proofy">Funnelish™</a>
                        </span>
										</div>
									</div>
								</span>
			        </div>
		        </div>
	        </div>
        </div>

	    <!-- Quick links -->
	    <div class="layout-column quick-links-container">
		    <div>
			    <h1 class="title">Quick links</h1>
		    </div>
		    <div>
			    <ul>
				    <li>
					    <external-link href="https://docs.funnelish.com/apps/proofy"
					                   target="_blank" label="How to use Proofy app?"> </external-link>
				    </li>
			    </ul>
		    </div>
	    </div>

    </div>
</template>

<script>
import API from "@/api"
import VButton from "@/components/base/v-button";
import Popup from "@/components/base/popup";
import InputField from "@/components/base/input-field";
import ExternalLink from "@/components/base/external-link";

export default {
    name: "Proofy",
	components: {ExternalLink, InputField, Popup, VButton},
	mixins: [API],
	props: ["newUserApp"],
    data() {
        return {
	        fields: [
	          {id:"Credit card", value:"Credit card"},
		        {id:"Card number", value:"Card number"},
		        {id:"MM / YY", value:"MM / YY"},
		        {id:"CVC", value:"CVC"},
		        {id:"Total", value:"Total"},
		        {id:"After clicking {SUBMIT_BUTTON}, you will be redirected to PayPal to complete your purchase securely.",
					    value:"After clicking {SUBMIT_BUTTON}, you will be redirected to PayPal to complete your purchase securely."}
			    ],

	        translatePopup: false,
        	selectedOption: "paypal",
	        copied: false,
        }
    },
    computed: {
    	msg() {
    		if (this.newUserApp && this.newUserApp["message_text"]) {
    			let m = this.newUserApp["message_text"];
			    if (m.indexOf("[productname]") >= 0) {
				    m = m.replace("[productname]", "[your product name will be here]");
			    } else if (m.indexOf("{{productname}}") >= 0) {
				    m = m.replace("{{productname}}", "[your product name will be here]");
			    }
			    return m;
		    }
    		return "Bought [your product name will be here]";
	    },
	    theme() {
    		let m = ""
		    if (this.newUserApp && this.newUserApp["theme"]) {
			    m = this.newUserApp["theme"] + " ";
		    }
		    if (this.newUserApp && this.newUserApp["style"]) {
			    m += this.newUserApp["style"];
		    }
		    return m;
	    },

    },
    methods: {
    },
    mounted() {

    }
}
</script>

<style lang="scss" >
    .proofy-preview {
      padding: 0;
	    .proofy-container {
		    padding: 10px 15px;
		    height: 100%;
		    display: flex;
		    align-items: center;
		    justify-content: center;
	    }
	    .header {
		    span {
			    text-align: center;
			    font-weight: 500;
			    color: #98aacd;
			    margin-bottom: 5px;
		    }
	    }

	    .proofy.default {
		    display: flex;
		    flex-direction: row;
		    width: 350px;
		    min-width: 320px;
		    min-height: 65px;
		    height: 62px;
		    background: white;
		    color: #3c3d44;
		    //font-family: "Open Sans",Helvetica,Arial,sans-serif;
		    font-size: 12px;
		    font-weight: 300;
		    overflow: hidden;
		    border-radius: 30px;
		    box-shadow: 0 0 1px rgba(0, 0, 0, 0.25), 0 1px 2px rgba(0, 0, 0, 0.15), 0 8px 30px rgba(0, 0, 0, 0.10);
		    position: relative;
		    padding: 3px 3px;

		    &.dark {
			    background: #3c3d44;
			    color: white;
		    }
		    &.pink {
			    background: pink;
			    color: deeppink;
			    .time {
				    color: #ff38a4;
			    }
		    }
		    &.round {
			    border-radius: 30px !important;
		    }
		    &.square {
			    border-radius: 5px;
			    .avatar {
				    border-radius: 5px;
			    }
		    }
		    .verified-by {
			    margin-left: auto;
			    width: auto;
			    font-size: 11px;
			    display: flex;
			    align-items: center;
			    a {
				    margin-left: 4px;
				    font-weight: 600;
				    cursor: pointer;
				    color: cornflowerblue;
			    }
			    svg {
				    display: flex;
				    margin: 0 3px 0 0;
			    }
		    }
		    .time {
			    color: #999;
			    font-size: 11px;
			    font-family: "Lato", helvetica, arial, sans-serif;
			    display: flex;
			    flex-direction: row;
			    justify-content: space-between;
		    }
		    .image {
			    display: flex;
			    position: relative;
			    height: 100%;
			    //width: 60px;
		    }
		    .avatar {
			    border-bottom-left-radius: 50%;
			    border-top-left-radius: 50%;
			    border-bottom-right-radius: 50%;
			    border-top-right-radius: 50%;
			    height: 100%;
			    //width: 65px;
		    }
		    .default-message span {
			    line-height: 16px;
			    //display: block;
			    //width: 100%;
			    //padding-right: 10px;
			    white-space: nowrap;
			    overflow: hidden;
			    text-overflow: ellipsis;
			    margin: 0;
			    height: 100%;
		    }
		    .default-message {
			    line-height: 16px;
			    padding: 1px 3px;
			    max-width: 280px;
			    display: flex;
			    flex-direction: column;
			    justify-content: space-between;
			    height: 100%;
			    width: 100%;
		    }
	    }
  }
</style>
